<template>
  <sa-page-layout :btnConfigurazioniVisible="true" :linkConfigurazioni="linkConfigurazioni" :btnRefreshVisible="true"
    :showModalLoading="showModalLoading" :pathResource="pathResource" titoloVisible @refresh="onRefresh">
    <template slot="toolbar">
      <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm"
        @click="onClickNuovoMetodoPagamento">
        <b-icon icon="plus"></b-icon>
        Nuovo
      </b-button>
    </template>
    <template slot="table-body">
      <configurazione-contabilita-metodi-pagamento-list-component @edit="onEditRigaIva"
        ref="cmpConfigurazioneContabilitaMetodiPagamentoListComponent" />
      <!-- <configurazione-contabilita-causali-tipo-documenti-list-component ref="cmpConfigurazioneContabilitaCausaliTipoDocumentiListComponent" @editCausaleDocumento="onEditCausaleDocumento"></configurazione-contabilita-causali-tipo-documenti-list-component> -->
      <ConfigurazioneContabilitaMetodiPagamentoEditModalComponent @afterSave="onAfterSave"
        ref="mdlConfigurazioneContabilitaMetodiPagamentoEditModalComponent" />
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneContabilitaMetodiPagamentoListComponent from "../components/ConfigurazioneContabilitaMetodiPagementoListComponent.vue";
import ConfigurazioneContabilitaMetodiPagamentoEditModalComponent from "../components/ConfigurazioneContabilitaMetodiPagamentoEditModalComponent.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";

export default {
  mixins: [StruttureMixin, ContabilitaMixin],
  components: { SaPageLayout, ConfigurazioneContabilitaMetodiPagamentoListComponent, ConfigurazioneContabilitaMetodiPagamentoEditModalComponent },
  data() {
    return {
      showModalLoading: false,
      pathResource: null,
      strutturaOptions: [],
      linkConfigurazioni: "/configurazionecontabilita",
    };
  },
  mounted() {
    this.contabilitaMetodiPagamentoLoadData();
  },
  methods: {
    onClickNuovoMetodoPagamento() {
      let me = this;
      me.$refs.mdlConfigurazioneContabilitaMetodiPagamentoEditModalComponent.show({ id: null });
    },
    onAfterSave() {
      this.onRefresh();
    },
    onRefresh() {
      this.$refs.cmpConfigurazioneContabilitaMetodiPagamentoListComponent.loadData();
    },
    onEditRigaIva(item) {
      let me = this;
      console.log(item);

      me.$refs.mdlConfigurazioneContabilitaMetodiPagamentoEditModalComponent.show(item);
    },
  },
};
</script>

<style></style>
